import { Link, Outlet } from 'react-router';

export default function Liquidity() {
   return (
         <Outlet />
   );
}
